import LegalPage from "./LegalPage";

export default function CGV() {
  return (
    <LegalPage
      title="Conditions Générales de Vente"
      subtitle="Les présentes CGV régissent les ventes en ligne et au comptoir de la SASU Saveurs Normandes (ci-après « le Vendeur »). Toute commande implique l'acceptation sans réserve des présentes."
      lastUpdate="Mai 2026"
      testid="page-cgv"
    >
      <h2>Article 1 — Identification du Vendeur</h2>
      <p>
        SASU SAVEURS NORMANDES — 4 rue de la Laiterie, 27400 Louviers, France · SIRET : 990 061 350 00015 · RCS Évreux 990 061 350 · TVA : FR24990061350 · Capital : 2 000 € · Licence IV · Tél. 06 65 02 87 00 · <a href="mailto:e.awono@saveursnormandes.fr">e.awono@saveursnormandes.fr</a>.
      </p>

      <h2>Article 2 — Objet</h2>
      <p>
        Les présentes CGV régissent l'ensemble des transactions de vente en ligne réalisées sur le site <strong>saveursnormandes.fr</strong> (boutique de rhums arrangés en bouteilles, cartes cadeaux, billetterie d'événements, prestations de bar mobile) ainsi que toute commande passée au sein de l'établissement physique de Louviers.
      </p>

      <h2>Article 3 — Conditions d'achat — Vente d'alcool aux majeurs uniquement</h2>
      <p>
        Conformément à l'article L.3342-1 du Code de la santé publique, la vente d'alcool est interdite aux mineurs de moins de 18 ans. En passant commande, le client <strong>certifie sur l'honneur avoir 18 ans révolus</strong>. Le Vendeur se réserve le droit de demander une pièce d'identité à la livraison ou au retrait, et d'annuler toute commande en cas de fausse déclaration.
      </p>
      <p className="p-4 border border-primary/40 bg-primary/5 rounded-lg">
        <strong>L'abus d'alcool est dangereux pour la santé. À consommer avec modération.</strong>
      </p>

      <h2>Article 4 — Produits</h2>
      <p>
        Les produits proposés à la vente sont décrits avec la plus grande exactitude possible. Les photographies sont non contractuelles : la couleur du liquide ou la teinte de l'étiquette peuvent légèrement varier en raison du caractère artisanal de la macération.
      </p>
      <p>
        Toutes les bouteilles vendues sont conditionnées en 70 cl, avec un degré d'alcool indiqué sur la fiche produit. Les rhums arrangés sont des produits artisanaux non standardisés et non pasteurisés.
      </p>

      <h2>Article 5 — Prix</h2>
      <p>
        Les prix affichés sur le site sont en euros, toutes taxes comprises (TTC), hors frais de livraison. Les frais de livraison sont calculés en fonction du poids total de la commande (1 bouteille = 1,60 kg) selon la grille tarifaire <strong>Colissimo Pro</strong>.
      </p>
      <p>
        <strong>Commandes supérieures à 15 kg :</strong> merci de nous contacter à <a href="mailto:contact@saveursnormandes.fr">contact@saveursnormandes.fr</a> pour l'établissement d'un devis personnalisé.
      </p>
      <p>
        Le Vendeur se réserve le droit de modifier ses prix à tout moment, étant entendu que le prix figurant au catalogue le jour de la commande sera le seul applicable au client.
      </p>

      <h2>Article 6 — Commande</h2>
      <p>
        Le client valide sa commande après avoir vérifié le contenu de son panier et accepté les présentes CGV. La validation finale du paiement vaut acceptation définitive de la commande. Un email de confirmation est automatiquement adressé.
      </p>

      <h2>Article 7 — Paiement</h2>
      <p>
        Le paiement s'effectue en ligne par carte bancaire via la plateforme sécurisée <strong>Stripe</strong> (Stripe Payments Europe Ltd.). Aucune information de carte bancaire n'est conservée par le Vendeur. Les transactions sont chiffrées en SSL/TLS.
      </p>
      <p>
        Cartes acceptées : Visa, MasterCard, American Express, Carte Bleue.
      </p>

      <h2>Article 8 — Livraison</h2>
      <h3>8.1 — Délais</h3>
      <p>
        Les commandes sont expédiées sous 2 à 5 jours ouvrés à compter de la réception du paiement. Le transporteur unique est <strong>Colissimo Pro (La Poste)</strong>, avec un délai indicatif de 2 à 3 jours ouvrés en France métropolitaine.
      </p>

      <h3>8.2 — Zones de livraison</h3>
      <p>
        La livraison est assurée en France métropolitaine. Pour la Corse, l'outre-mer ou l'international, contactez-nous au préalable.
      </p>

      <h3>8.3 — Retrait au bar</h3>
      <p>
        Le retrait gratuit en boutique est possible aux horaires d'ouverture (mardi-samedi 17h-23h) au 4 rue de la Laiterie, 27400 Louviers. Une pièce d'identité sera demandée.
      </p>

      <h3>8.4 — Bouteille cassée à la livraison</h3>
      <p>
        En cas de bouteille cassée, abîmée ou colis endommagé à la réception, le client doit nous contacter <strong>dans un délai de 48 heures</strong> à compter de la livraison, en joignant des <strong>photographies du colis et de la bouteille</strong>. Saveurs Normandes procédera au <strong>remplacement gratuit</strong> de la bouteille concernée, frais d'expédition inclus.
      </p>

      <h2>Article 9 — Droit de rétractation — Exception légale pour les boissons alcoolisées</h2>
      <p>
        Conformément à l'<strong>article L.221-28 du Code de la consommation</strong>, le droit de rétractation de 14 jours <strong>ne s'applique pas</strong> aux contrats portant sur la fourniture de :
      </p>
      <ul>
        <li>biens scellés ne pouvant être renvoyés pour des raisons d'hygiène ou de protection de la santé une fois descellés ;</li>
        <li>boissons alcoolisées dont la livraison est différée au-delà de 30 jours et dont la valeur convenue à la conclusion du contrat dépend de fluctuations sur le marché échappant au contrôle du professionnel ;</li>
        <li>biens confectionnés selon les spécifications du consommateur ou nettement personnalisés (cas des cartes cadeaux personnalisées et bouteilles dédicacées).</li>
      </ul>
      <p>
        En conséquence, <strong>les commandes de boissons alcoolisées et de cartes cadeaux personnalisées ne peuvent faire l'objet d'aucune rétractation</strong>, hors cas de produit défectueux (voir article 8.4).
      </p>

      <h2>Article 10 — Réservation d'événements et ateliers</h2>
      <p>
        Les billets d'afterworks, ateliers cocktails et ateliers rhum arrangé sont nominatifs et non remboursables. En cas d'impossibilité d'assister à l'événement, le client peut céder sa place à un tiers majeur, à condition d'en informer le Vendeur par email au moins 24h avant l'événement.
      </p>
      <p>
        En cas d'annulation par le Vendeur (force majeure, nombre minimum de participants non atteint, etc.), le client est intégralement remboursé.
      </p>

      <h2>Article 11 — Cartes cadeaux</h2>
      <p>
        Les cartes cadeaux digitales émises par Saveurs Normandes sont valables 12 mois à compter de la date d'achat. Elles peuvent être utilisées en une ou plusieurs fois sur la billetterie d'événements et la boutique en ligne. Elles ne sont ni reprises ni échangées contre du numéraire et ne sont pas remboursables.
      </p>

      <h2>Article 12 — Bar mobile et prestations privées</h2>
      <p>
        Les demandes de devis pour le bar mobile (mariages, EVG, événements professionnels…) font l'objet d'un contrat séparé. Un acompte de 30% du montant total est demandé pour valider la prestation. Le solde est dû le jour de l'événement. Toute annulation à moins de 30 jours de l'événement entraîne la conservation de l'acompte.
      </p>

      <h2>Article 13 — Garantie de conformité</h2>
      <p>
        Le Vendeur est tenu des garanties légales de conformité (articles L.217-4 à L.217-12 du Code de la consommation) et des vices cachés (articles 1641 à 1648 et 2232 du Code civil). Toute réclamation doit être adressée par email à <a href="mailto:e.awono@saveursnormandes.fr">e.awono@saveursnormandes.fr</a>.
      </p>

      <h2>Article 14 — Responsabilité</h2>
      <p>
        Le Vendeur ne saurait être tenu pour responsable de l'inexécution du contrat conclu en cas de force majeure, de perturbation ou grève totale ou partielle notamment des services postaux et moyens de transport et/ou communications, inondation, incendie.
      </p>

      <h2>Article 15 — Litiges et médiation</h2>
      <p>
        Les présentes CGV sont soumises au droit français. En cas de litige, le client peut recourir gratuitement au service de médiation de la consommation. Conformément à l'article L.612-1 du Code de la consommation, le client peut également recourir à la plateforme de Règlement en Ligne des Litiges (RLL) de la Commission européenne : <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">ec.europa.eu/consumers/odr</a>.
      </p>
      <p>
        À défaut d'accord amiable, les tribunaux français du ressort d'Évreux seront seuls compétents.
      </p>

      <h2>Article 16 — Données personnelles</h2>
      <p>
        Le traitement des données personnelles collectées dans le cadre des commandes est détaillé dans notre <a href="/confidentialite">Politique de confidentialité</a>.
      </p>

      <h2>Article 17 — Acceptation des CGV</h2>
      <p>
        En cochant la case d'acceptation lors de la finalisation de la commande ou en validant le paiement, le client reconnaît avoir lu, compris et accepté sans réserve les présentes Conditions Générales de Vente.
      </p>
    </LegalPage>
  );
}
